import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';

export default{
  name: 'SignedContract',
  mixins: [alert_mixin],
  components: {NavigationBackButton},

  data: () => ({
    steps: ["Founder", "Trustee", "Accountant", "Agent", "Administrator"],
    current_step: 1,
    contract_status: 'pending',
    contract_details: {
      title: 'Trust Protector Agreement',
      date_sent: 'June 10, 2025 at 9:15 AM',
      date_received: 'June 11, 2025 at 2:30 PM',
      completed_by: 'Admin User',
      completed_at: 'June 11, 2025 at 2:34 PM',
    },
    rejection_reason: ''
  }),

  methods:{
    approve_contract(){
      this.contract_status = 'approved';
      this.show_success('Contract approved.');
    },

    reject_contract(reason){
      this.rejection_reason =reason;
      this.contract_status = 'rejected';
      this.show_success('rejectection message sent successfully.');
      this.close_modal('reject_contract')

    }
  }

}